import React, {Fragment,useState, useEffect} from 'react'
import { useHistory } from "react-router-dom";
import axios from 'axios';
import Context from '../../Context'

export const CategoriaTitulo = (props) => {
    const [etiquetasEvento, setEtiquetasEvento] = useState(false)
    const [colorEtiquetasEvento, setColorEtiquetasEvento] = useState(false)
    const getDatosCategoria = async (cat) => {
       
        let dataFormEventos = {  
            "tipoCategoria":"etiqueta"
            
        }
        
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                
            },  
        };
        
        axios.post(`${process.env.REACT_APP_URL_API}formatos/ObtenerCategorias`, dataFormEventos, axiosConfig)
        .then((res) => {
           
            res.data.data.map(item =>{
                if(item.idCategoria == props.idCategoria){
                    setEtiquetasEvento(item.descripcion)
                    setColorEtiquetasEvento(item.color)
                }
            }) 
        })
        .catch((err) => {
            
        }) 
    }

    useEffect(() => {
        getDatosCategoria();
    },[props.idCategoria]) 

    if(!etiquetasEvento) {return(<Fragment></Fragment>) }   
    
    return  (
        
                <div key={Math.random() * 57005} style={{color: colorEtiquetasEvento}} className="card-section">{etiquetasEvento}</div>
        
    )
    
}



